import { TotalPrice } from '@/components/TotalPrice/TotalPrice'
import type { ShopSession } from '@/services/shopSession/ShopSession.types'
import { getSummarisedPrice } from '@/utils/getOfferPrice'

type Props = {
  cost: ShopSession['cart']['cost']
}

export function CartTotal({ cost }: Props) {
  const { currencyCode, amount, reducedAmount } = getSummarisedPrice(cost)

  return <TotalPrice currencyCode={currencyCode} amount={amount} reducedAmount={reducedAmount} />
}
